/** SC-FOREST-02 package, 2026-10-29. Editorial research only; null identities stay null. */
export const forestEditorial = {
  issues: [
    {
      editorialKey: 'FOREST-ISSUE-01',
      sourceIssueId: null,
      formalScenarioId: null,
      title: '火情线索与早期核实',
      summary:
        '卫星热点、山林烟点、视频告警或巡护报告都是需要核实的火情线索。要先明确线索的时间、位置和来源，再比对其他观察，不应直接当成已经发生的森林火灾。',
      question: '线索是否可靠、位于哪里，后续还需要什么佐证？',
      informationRequirements: [
        {
          displayName: '线索位置与观测时间',
          whyNeeded: '记录坐标、观测时刻、来源及数据有效期。',
          possibleSources: '卫星观测记录、视频记录、巡护报告',
          actualRequirementId: null,
          status: '通常需要了解,非当前已获数据',
        },
        {
          displayName: '多来源观察',
          whyNeeded: '对比卫星、航空、瞭望、视频与巡护信息是否一致。',
          possibleSources: '不同来源的时间戳与原始记录',
          actualRequirementId: null,
          status: '通常需要了解,非当前已获数据',
        },
        {
          displayName: '现场核实情况',
          whyNeeded: '标注是否已被专业人员核实及核实时间；未获得时保持未知。',
          possibleSources: '核实记录或专业人员报告',
          actualRequirementId: null,
          status: '通常需要了解,非当前已获数据',
        },
      ],
      editorialCapabilityKeys: ['CAP-SIGNAL', 'CAP-AIR', 'CAP-VIDEO', 'CAP-COMMS'],
      actualCapabilityIds: [],
      officialSourceIds: ['CN-MON-2024', 'CN-UAV-47054', 'CN-VIDEO-47058', 'NASA-FIRMS'],
      caseIds: ['PRACTICE-DRONE-2026'],
      mediaPath: '04_MEDIA/illustrations/01-early-signal.webp',
      mediaType: '原创原理示意',
      professionalReview: '待专业审核',
      rankPriority: null,
      capabilityContexts: [
        {
          editorialCapabilityKey: 'CAP-SIGNAL',
          inThisIssuePurpose:
            '把卫星热点、视频告警和巡护报告按观测时间、坐标与来源并列，辅助发现需要进一步核查的位置。',
          expectedOutputInThisIssue: '多源线索对照清单与待核实信息',
          formalCapabilityId: null,
        },
        {
          editorialCapabilityKey: 'CAP-AIR',
          inThisIssuePurpose: '在具备巡查条件及授权时，从空中补充疑似烟点附近的观察画面。',
          expectedOutputInThisIssue: '带时间和位置的空中观察记录',
          formalCapabilityId: null,
        },
        {
          editorialCapabilityKey: 'CAP-VIDEO',
          inThisIssuePurpose: '调阅固定视频或瞭望记录，对照疑似烟点出现时刻和方向。',
          expectedOutputInThisIssue: '远距离可见光或合适配置的热像观测线索',
          formalCapabilityId: null,
        },
        {
          editorialCapabilityKey: 'CAP-COMMS',
          inThisIssuePurpose: '把地面核查人员的确认或否认结果回传给研究与指挥信息整理端。',
          expectedOutputInThisIssue: '带来源与时间的核实反馈',
          formalCapabilityId: null,
        },
      ],
    },
    {
      editorialKey: 'FOREST-ISSUE-02',
      sourceIssueId: null,
      formalScenarioId: null,
      title: '气象与火势变化条件',
      summary:
        '风速风向、温度、湿度、降水和植被情况会影响森林火险信息的理解。应将数据的地点、时间与测量方式一起展示，不能由单个天气值直接推导火险等级。',
      question: '什么环境条件可能影响火情变化？',
      informationRequirements: [
        {
          displayName: '风向风速及变化',
          whyNeeded: '结合观测地点、时刻了解风的变化趋势。',
          possibleSources: '气象站数据、官方气象预报',
          actualRequirementId: null,
          status: '通常需要了解,非当前已获数据',
        },
        {
          displayName: '气温湿度与降水',
          whyNeeded: '区分观测值、预报值和各自生效时间。',
          possibleSources: '气象观测及预报',
          actualRequirementId: null,
          status: '通常需要了解,非当前已获数据',
        },
        {
          displayName: '植被与可燃物条件',
          whyNeeded: '了解树种、枯落物、干燥条件等已有资料。',
          possibleSources: '林草资源资料、巡护观察',
          actualRequirementId: null,
          status: '通常需要了解,非当前已获数据',
        },
        {
          displayName: '前后观测记录',
          whyNeeded: '对比同类观察资料，不能用单帧图像认定火场发展速度。',
          possibleSources: '有时间戳的卫星、无人机或视频记录',
          actualRequirementId: null,
          status: '通常需要了解,非当前已获数据',
        },
      ],
      editorialCapabilityKeys: ['CAP-METEO', 'CAP-MULTISOURCE', 'CAP-AIR'],
      actualCapabilityIds: [],
      officialSourceIds: ['CN-MON-2024', 'CN-REG-822', 'CN-SPEC-3437'],
      caseIds: [],
      mediaPath: '04_MEDIA/illustrations/02-weather-change.webp',
      mediaType: '原创原理示意',
      professionalReview: '待专业审核',
      rankPriority: null,
      capabilityContexts: [
        {
          editorialCapabilityKey: 'CAP-METEO',
          inThisIssuePurpose:
            '记录与疑似火情地点和时刻有关的风、温湿度与降水信息，并区分预报和实测。',
          expectedOutputInThisIssue: '带时间地点的环境条件资料',
          formalCapabilityId: null,
        },
        {
          editorialCapabilityKey: 'CAP-MULTISOURCE',
          inThisIssuePurpose: '按时间对照林区多次观察画面与气象记录，提示变化是否具有共同背景。',
          expectedOutputInThisIssue: '变化对照视图与待解释差异',
          formalCapabilityId: null,
        },
        {
          editorialCapabilityKey: 'CAP-AIR',
          inThisIssuePurpose:
            '在允许开展巡查时补充不同时间的外部画面，但不据此自动推算火势扩散速度。',
          expectedOutputInThisIssue: '连续时间点的外部观察图像',
          formalCapabilityId: null,
        },
      ],
    },
    {
      editorialKey: 'FOREST-ISSUE-03',
      sourceIssueId: null,
      formalScenarioId: null,
      title: '地形道路与重点保护对象',
      summary:
        '山脊、沟谷、道路和周边村镇影响地理信息的理解与现场资料收集。地图上的道路、河流和居民点只是基础信息，不能当作实时可通行或已完成核实。',
      question: '地形、通道和需要重点关注的对象分布在哪里？',
      informationRequirements: [
        {
          displayName: '地形与坡谷信息',
          whyNeeded: '参考地形图，标记地理特征和资料日期。',
          possibleSources: '已有地形地图、遥感底图',
          actualRequirementId: null,
          status: '通常需要了解,非当前已获数据',
        },
        {
          displayName: '道路与通行条件',
          whyNeeded: '分清地图道路与当前道路是否可通行。',
          possibleSources: '道路资料、巡护核实、交通管控信息',
          actualRequirementId: null,
          status: '通常需要了解,非当前已获数据',
        },
        {
          displayName: '居民点与重要设施',
          whyNeeded: '核对附近聚落、设施和受影响对象的位置。',
          possibleSources: '行政地名、重要目标档案',
          actualRequirementId: null,
          status: '通常需要了解,非当前已获数据',
        },
      ],
      editorialCapabilityKeys: ['CAP-GEO', 'CAP-AIR', 'CAP-VIDEO'],
      actualCapabilityIds: [],
      officialSourceIds: ['CN-SPEC-3437', 'CN-REG-822', 'CN-MON-2024'],
      caseIds: [],
      mediaPath: '04_MEDIA/illustrations/03-terrain-road.webp',
      mediaType: '原创原理示意',
      professionalReview: '待专业审核',
      rankPriority: null,
      capabilityContexts: [
        {
          editorialCapabilityKey: 'CAP-GEO',
          inThisIssuePurpose: '查阅林区山脊沟谷、河流和道路分布，明确资料更新时间。',
          expectedOutputInThisIssue: '位置关系图与需现场核实的通行项',
          formalCapabilityId: null,
        },
        {
          editorialCapabilityKey: 'CAP-AIR',
          inThisIssuePurpose: '从空中观察地图信息可能无法反映的道路障碍或地形状况。',
          expectedOutputInThisIssue: '有时间的外围地形和道路画面',
          formalCapabilityId: null,
        },
        {
          editorialCapabilityKey: 'CAP-VIDEO',
          inThisIssuePurpose: '使用可用瞭望或视频画面关注重点保护对象周边的可观察情况。',
          expectedOutputInThisIssue: '已有监控覆盖区域的观察记录',
          formalCapabilityId: null,
        },
      ],
    },
    {
      editorialKey: 'FOREST-ISSUE-04',
      sourceIssueId: null,
      formalScenarioId: null,
      title: '人员安全与疏散线索',
      summary:
        '森林火灾可能影响林区工作人员、周边居民、游客及其他人员。平台应列出需要了解的位置、联络与通行信息，不自动生成撤离路线或作战指令。',
      question: '哪些人可能受到影响，是否能联系，信息还缺什么？',
      informationRequirements: [
        {
          displayName: '人员线索与位置',
          whyNeeded: '区分报告位置、已核实位置和未知。',
          possibleSources: '巡护记录、人员上报、官方核实',
          actualRequirementId: null,
          status: '通常需要了解,非当前已获数据',
        },
        {
          displayName: '联络状态',
          whyNeeded: '核查人员是否可以接收信息和反馈。',
          possibleSources: '通信记录、联络测试',
          actualRequirementId: null,
          status: '通常需要了解,非当前已获数据',
        },
        {
          displayName: '通道与风险区域',
          whyNeeded: '结合现有地图和经过核实的管制信息整理关注点。',
          possibleSources: '道路和交通部门信息、专业现场确认',
          actualRequirementId: null,
          status: '通常需要了解,非当前已获数据',
        },
      ],
      editorialCapabilityKeys: ['CAP-PERSON', 'CAP-COMMS', 'CAP-GEO'],
      actualCapabilityIds: [],
      officialSourceIds: ['CN-REG-822', 'CN-SAFETY-35', 'CN-FIRE-PLAN-2020'],
      caseIds: [],
      mediaPath: '04_MEDIA/illustrations/04-people-protection.webp',
      mediaType: '原创原理示意',
      professionalReview: '待专业审核',
      rankPriority: null,
      capabilityContexts: [
        {
          editorialCapabilityKey: 'CAP-PERSON',
          inThisIssuePurpose: '整理巡护人员和周边人员的报告，区分未经核实的线索与已确认联络。',
          expectedOutputInThisIssue: '人员线索登记与反馈状态',
          formalCapabilityId: null,
        },
        {
          editorialCapabilityKey: 'CAP-COMMS',
          inThisIssuePurpose: '为不同联络对象提供已知的语音或数据通路信息，显示联系尝试结果。',
          expectedOutputInThisIssue: '联络状态与沟通记录',
          formalCapabilityId: null,
        },
        {
          editorialCapabilityKey: 'CAP-GEO',
          inThisIssuePurpose: '结合已有地形道路资料标记需要专业核查的人口聚落和设施位置。',
          expectedOutputInThisIssue: '位置关系和待核查对象清单',
          formalCapabilityId: null,
        },
      ],
    },
    {
      editorialKey: 'FOREST-ISSUE-05',
      sourceIssueId: null,
      formalScenarioId: null,
      title: '林区通信与信息回传',
      summary:
        '偏远林区的地形、供电条件和网络覆盖可能使联络与视频回传受限。需要掌握有哪些通路、谁能联系谁、视频与定位能否按预期送达。',
      question: '现场与后方之间能否稳定交流信息？',
      informationRequirements: [
        {
          displayName: '已有通信方式',
          whyNeeded: '罗列无线电、公网、卫星或其他已部署通信类型及覆盖假设。',
          possibleSources: '现有通信方案资料',
          actualRequirementId: null,
          status: '通常需要了解,非当前已获数据',
        },
        {
          displayName: '联络对象与链路',
          whyNeeded: '明确通信对象、实测时间和反馈结果。',
          possibleSources: '通信测试与运维记录',
          actualRequirementId: null,
          status: '通常需要了解,非当前已获数据',
        },
        {
          displayName: '中继与供电条件',
          whyNeeded: '了解临时中继设备、电源和地形适用性。',
          possibleSources: '设备资料及本地核实记录',
          actualRequirementId: null,
          status: '通常需要了解,非当前已获数据',
        },
      ],
      editorialCapabilityKeys: ['CAP-COMMS', 'CAP-RELAY', 'CAP-AIR'],
      actualCapabilityIds: [],
      officialSourceIds: ['CN-MON-2024', 'CN-FORESTRY-RELAY', 'CN-REG-822'],
      caseIds: ['PRACTICE-REL-2026'],
      mediaPath: '04_MEDIA/illustrations/05-remote-communication.webp',
      mediaType: '原创原理示意',
      professionalReview: '待专业审核',
      rankPriority: null,
      capabilityContexts: [
        {
          editorialCapabilityKey: 'CAP-COMMS',
          inThisIssuePurpose: '识别现场设备、巡护人员与后方之间已有的通信方式，核对是否近期测试。',
          expectedOutputInThisIssue: '联系对象、链路类型和测通结果',
          formalCapabilityId: null,
        },
        {
          editorialCapabilityKey: 'CAP-RELAY',
          inThisIssuePurpose: '在原有网络不足时研究卫星地面站、中继设备等替代通路的适用条件。',
          expectedOutputInThisIssue: '不同通信方案的覆盖假设和测试记录',
          formalCapabilityId: null,
        },
        {
          editorialCapabilityKey: 'CAP-AIR',
          inThisIssuePurpose: '在获准条件下配合空中设备采集巡护画面，并研究能否可靠回传。',
          expectedOutputInThisIssue: '带时间的观察视频与传输记录',
          formalCapabilityId: null,
        },
      ],
    },
    {
      editorialKey: 'FOREST-ISSUE-06',
      sourceIssueId: null,
      formalScenarioId: null,
      title: '火源风险与日常巡护',
      summary:
        '森林防火大量工作发生在事故之前。日常应关注火源活动、巡护覆盖、重点防火区域与相关规则，并记录线索来源及最新更新时间。',
      question: '哪些日常行为或条件需要持续关注？',
      informationRequirements: [
        {
          displayName: '巡护区域和记录',
          whyNeeded: '查看巡护覆盖范围、日期与重点地点。',
          possibleSources: '巡护台账、瞭望记录',
          actualRequirementId: null,
          status: '通常需要了解,非当前已获数据',
        },
        {
          displayName: '火源活动线索',
          whyNeeded: '区分已确认野外用火与尚待核实的报告。',
          possibleSources: '巡护发现、检查站记录、官方调查',
          actualRequirementId: null,
          status: '通常需要了解,非当前已获数据',
        },
        {
          displayName: '本地防火期规则',
          whyNeeded: '关联有效的本地防火期和火源管理要求。',
          possibleSources: '当期有效地方规定',
          actualRequirementId: null,
          status: '通常需要了解,非当前已获数据',
        },
      ],
      editorialCapabilityKeys: ['CAP-PATROL', 'CAP-VIDEO', 'CAP-SIGNAL'],
      actualCapabilityIds: [],
      officialSourceIds: ['CN-REG-822', 'CN-MON-2024', 'CN-ANHUI-5', 'CN-UAV-47054'],
      caseIds: [
        'CASE-AH-01',
        'CASE-AH-02',
        'CASE-AH-03',
        'CASE-AH-04',
        'CASE-AH-05',
        'PRACTICE-PATROL-2026',
      ],
      mediaPath: '04_MEDIA/illustrations/06-daily-patrol.webp',
      mediaType: '原创原理示意',
      professionalReview: '待专业审核',
      rankPriority: null,
      capabilityContexts: [
        {
          editorialCapabilityKey: 'CAP-PATROL',
          inThisIssuePurpose: '整理各巡护区域的时间、路线、问题与处理记录，为长期复查提供线索。',
          expectedOutputInThisIssue: '巡护台账与待处理问题记录',
          formalCapabilityId: null,
        },
        {
          editorialCapabilityKey: 'CAP-VIDEO',
          inThisIssuePurpose: '结合已有视频监控和瞭望资料关注进山入口、重点林段的可见异常。',
          expectedOutputInThisIssue: '有来源和时间的视频观察条目',
          formalCapabilityId: null,
        },
        {
          editorialCapabilityKey: 'CAP-SIGNAL',
          inThisIssuePurpose:
            '把公众报告、巡护发现和官方历史案例中的火源风险类型归档，不自动认定违法行为。',
          expectedOutputInThisIssue: '火源风险分类和待核实线索',
          formalCapabilityId: null,
        },
      ],
    },
  ],
  capabilities: [
    {
      editorialKey: 'CAP-SIGNAL',
      actualCapabilityId: null,
      displayNameZh: '监测线索汇总与核查辅助',
      whyInForest: '将不同来源的火点、烟点或报告按时间与位置整理，辅助进行核实。',
      expectedOutputs: '已标记来源的线索集合与待核实项',
      limitations: '热点和烟点存在误判；不自动确认起火。',
      illustration: '04_MEDIA/illustrations/01-early-signal.webp',
      reviewStatus: 'editorial_reference_not_certified',
      canNavigateExactCapability: false,
    },
    {
      editorialKey: 'CAP-AIR',
      actualCapabilityId: null,
      displayNameZh: '无人机空中巡查与观察',
      whyInForest: '按已获准的巡查任务获取空中画面、位置线索和时间记录。',
      expectedOutputs: '可见光/合适配置下的热成像资料、航拍记录',
      limitations: '受飞行条件、空域、天气、机型和操作者能力限制。',
      illustration: '04_MEDIA/illustrations/01-early-signal.webp',
      reviewStatus: 'editorial_reference_not_certified',
      canNavigateExactCapability: false,
    },
    {
      editorialKey: 'CAP-VIDEO',
      actualCapabilityId: null,
      displayNameZh: '固定视频与瞭望观察',
      whyInForest: '使用已有摄像与瞭望信息观察林区可见现象。',
      expectedOutputs: '带时间的观察视频或图像',
      limitations: '视线遮挡、覆盖范围、误报和视频可用性需验证。',
      illustration: '04_MEDIA/illustrations/01-early-signal.webp',
      reviewStatus: 'editorial_reference_not_certified',
      canNavigateExactCapability: false,
    },
    {
      editorialKey: 'CAP-COMMS',
      actualCapabilityId: null,
      displayNameZh: '通信与信息回传',
      whyInForest: '在相关终端与网络满足条件时传输语音、位置和图像。',
      expectedOutputs: '语音联络、位置报文、图像传输记录',
      limitations: '不等于所有林区自动有信号；不保证链路实际可达。',
      illustration: '04_MEDIA/illustrations/05-remote-communication.webp',
      reviewStatus: 'editorial_reference_not_certified',
      canNavigateExactCapability: false,
    },
    {
      editorialKey: 'CAP-METEO',
      actualCapabilityId: null,
      displayNameZh: '气象与环境信息获取',
      whyInForest: '整理气象观测及预报资料，了解不同时间和地点的环境条件。',
      expectedOutputs: '风、温湿度、降水等有来源的数据',
      limitations: '预报与实测不可混用；不能由单项指标自动判定火险级别。',
      illustration: '04_MEDIA/illustrations/02-weather-change.webp',
      reviewStatus: 'editorial_reference_not_certified',
      canNavigateExactCapability: false,
    },
    {
      editorialKey: 'CAP-MULTISOURCE',
      actualCapabilityId: null,
      displayNameZh: '多源观测与变化对照',
      whyInForest: '比对不同时刻的观察信息，并明确时间、地点和差异来源。',
      expectedOutputs: '时间线、观察差异、待确认变化',
      limitations: '画面对比不意味着精确火线或趋势预测。',
      illustration: '04_MEDIA/illustrations/02-weather-change.webp',
      reviewStatus: 'editorial_reference_not_certified',
      canNavigateExactCapability: false,
    },
    {
      editorialKey: 'CAP-GEO',
      actualCapabilityId: null,
      displayNameZh: '地理与道路资料查看',
      whyInForest: '整合地形、林区道路和居民点等已有地理信息，作为核对入口。',
      expectedOutputs: '地形图、位置关系与资料清单',
      limitations: '地图存在不等于道路可通行；位置数据可能过期。',
      illustration: '04_MEDIA/illustrations/03-terrain-road.webp',
      reviewStatus: 'editorial_reference_not_certified',
      canNavigateExactCapability: false,
    },
    {
      editorialKey: 'CAP-PERSON',
      actualCapabilityId: null,
      displayNameZh: '人员信息联络与核实',
      whyInForest: '按照已有组织职责整理人员线索、联络渠道及反馈。',
      expectedOutputs: '已核实和待核实人员线索、联络记录',
      limitations: '不从通用知识推断具体人员的安全状态。',
      illustration: '04_MEDIA/illustrations/04-people-protection.webp',
      reviewStatus: 'editorial_reference_not_certified',
      canNavigateExactCapability: false,
    },
    {
      editorialKey: 'CAP-RELAY',
      actualCapabilityId: null,
      displayNameZh: '临时通信中继与补盲',
      whyInForest: '在适配情况下通过中继或卫星方式增强现场通信与数据回传。',
      expectedOutputs: '链路测试结果、覆盖说明、视频/语音可达性',
      limitations: '依赖设备配置、电源、天气与专业测试。',
      illustration: '04_MEDIA/illustrations/05-remote-communication.webp',
      reviewStatus: 'editorial_reference_not_certified',
      canNavigateExactCapability: false,
    },
    {
      editorialKey: 'CAP-PATROL',
      actualCapabilityId: null,
      displayNameZh: '日常巡护与风险记录',
      whyInForest: '记录巡护位置、日期、观察问题与处理情况，保留出处。',
      expectedOutputs: '巡护台账、风险地点记录和待处理事项',
      limitations: '不是自动执法、预警发布或火灾确认。',
      illustration: '04_MEDIA/illustrations/06-daily-patrol.webp',
      reviewStatus: 'editorial_reference_not_certified',
      canNavigateExactCapability: false,
    },
  ],
  cases: [
    {
      id: 'CASE-AH-01',
      title: '滁州凤阳县曹店国有林场森林火情',
      occurredAt: '2025-03-21',
      location: '滁州市凤阳县刘府镇曹店国有林场',
      summary: '官方通报：祭祀烧纸引发，过火面积约4亩；当天扑灭。',
      relatedIssue: '火源风险与日常巡护',
      sourceId: 'CN-ANHUI-5',
      kind: 'official_case',
      unverifiedDetailsProhibited: true,
    },
    {
      id: 'CASE-AH-02',
      title: '安庆太湖县海会村山场森林火情',
      occurredAt: '2025-03-21',
      location: '安庆市太湖县小池镇海会村',
      summary: '官方通报：当地居民祭祀烧纸引发，过火面积约26亩。',
      relatedIssue: '火源风险与日常巡护',
      sourceId: 'CN-ANHUI-5',
      kind: 'official_case',
      unverifiedDetailsProhibited: true,
    },
    {
      id: 'CASE-AH-03',
      title: '六安霍山县青枫岭村森林火情',
      occurredAt: '2025-03-21',
      location: '六安市霍山县大化坪镇青枫岭村',
      summary: '官方通报：施工过程中吸烟引发，过火面积约36亩；报道提到航空力量参与。',
      relatedIssue: '火源风险与日常巡护',
      sourceId: 'CN-ANHUI-5',
      kind: 'official_case',
      unverifiedDetailsProhibited: true,
    },
    {
      id: 'CASE-AH-04',
      title: '安庆怀宁县独秀山森林火情',
      occurredAt: '2025-03-22',
      location: '安庆市怀宁县黄墩镇独秀山',
      summary: '官方通报：祭祀烧冥币引发，过火面积约144亩。',
      relatedIssue: '火源风险与日常巡护',
      sourceId: 'CN-ANHUI-5',
      kind: 'official_case',
      unverifiedDetailsProhibited: true,
    },
    {
      id: 'CASE-AH-05',
      title: '合肥庐江县夹山蕻林场森林火情',
      occurredAt: '2025-03-25',
      location: '合肥市庐江县国有夹山蕻林场',
      summary: '官方通报：祭祀烧冥币引发，过火面积约167亩；报道提到航空力量参与。',
      relatedIssue: '火源风险与日常巡护',
      sourceId: 'CN-ANHUI-5',
      kind: 'official_case',
      unverifiedDetailsProhibited: true,
    },
    {
      id: 'PRACTICE-REL-2026',
      title: '十八站林业局空地一体化通信测试',
      occurredAt: '2026-10-10',
      location: '大兴安岭十八站林业局',
      summary:
        '官方实践报道：无人机与卫星便携站配合回传图像；属于通信测试与实践，不是火灾事故调查。',
      relatedIssue: '林区通信与信息回传',
      sourceId: 'CN-FORESTRY-RELAY',
      kind: 'official_practice',
      unverifiedDetailsProhibited: true,
    },
    {
      id: 'PRACTICE-DRONE-2026',
      title: '宁波森林火灾监测模拟拉练',
      occurredAt: '2026-04-11',
      location: '浙江宁波',
      summary: '官方采访报道包含模拟火情及视频监测应用；属于演练/实践，不是实际事故证明。',
      relatedIssue: '火情线索与早期核实',
      sourceId: 'CN-FORESTRY-DRONE',
      kind: 'official_practice',
      unverifiedDetailsProhibited: true,
    },
    {
      id: 'PRACTICE-PATROL-2026',
      title: '福建莆田村居森林防火管护实践',
      occurredAt: '2026-06-08',
      location: '福建莆田',
      summary: '官方实践报道记录巡护、监控与无人机巢等做法；不表示平台接入这些资源。',
      relatedIssue: '火源风险与日常巡护',
      sourceId: 'CN-FORESTRY-PATROL',
      kind: 'official_practice',
      unverifiedDetailsProhibited: true,
    },
  ],
  sources: [
    {
      id: 'CN-REG-822',
      title: '森林草原防灭火条例（国务院令第822号）',
      issuer: '国务院',
      sourceType: '现行行政法规',
      officialUrl: 'https://www.forestry.gov.cn/c/www/gkxzfg/659970.jhtml',
      dateOrEffective: '2026-01-01',
      usableFor: '预防、报告、预案职责、巡护、人员保障；不等于地方具体SOP',
      kind: 'official_page',
      verifiedBy: 'web-search/review-2026-10-29',
      localFileIncluded: false,
      fullTextLicense: 'not-granted-or-unverified',
      mustNotClaim: '本地SOP/现有设备/实时数据/火线/响应等级',
    },
    {
      id: 'CN-MON-2024',
      title: '关于加强森林草原火灾预警监测体系建设的实施意见（国森防发〔2024〕2号）',
      issuer: '国家森林草原防灭火指挥部',
      sourceType: '指导文件',
      officialUrl: 'https://www.mem.gov.cn/gk/zfxxgkpt/fdzdgknr/202409/t20240930_502744.shtml',
      dateOrEffective: '2024-09-30',
      usableFor: '六位一体监测、多源数据共享、核查反馈与预警协同；不自行设地方阈值',
      kind: 'official_page',
      verifiedBy: 'web-search/review-2026-10-29',
      localFileIncluded: false,
      fullTextLicense: 'not-granted-or-unverified',
      mustNotClaim: '本地SOP/现有设备/实时数据/火线/响应等级',
    },
    {
      id: 'CN-SPEC-3437',
      title: '森林草原防火信息系统技术要求 LY/T 3437—2025',
      issuer: '国家林业和草原局',
      sourceType: '现行推荐行业标准',
      officialUrl:
        'https://hbba.sacinfo.org.cn/stdDetail/3f1fe2172df9130f6163608a7aa27272fdb7ea3ff3b8ce180e307480ba8815ed',
      dateOrEffective: '2025-11-01',
      usableFor: '火灾、热点、人员队伍、通信、保障设施等数据结构参考',
      kind: 'standard_metadata',
      verifiedBy: 'web-search/review-2026-10-29',
      localFileIncluded: false,
      fullTextLicense: 'not-granted-or-unverified',
      mustNotClaim: '本地SOP/现有设备/实时数据/火线/响应等级',
    },
    {
      id: 'CN-UAV-47054',
      title: '森林草原防火 无人机巡查技术规范 GB/T 47054—2026',
      issuer: '国家市场监督管理总局/国家标准化管理委员会',
      sourceType: '现行推荐国家标准',
      officialUrl:
        'https://openstd.samr.gov.cn/bzgk/std/newGbInfo?hcno=A4FFC9C8C97423178424C5ABFC8F3BCE',
      dateOrEffective: '2026-05-01',
      usableFor: '无人机巡查人员、装备、安全和资料组织；不是设备性能认证',
      kind: 'standard_metadata',
      verifiedBy: 'web-search/review-2026-10-29',
      localFileIncluded: false,
      fullTextLicense: 'not-granted-or-unverified',
      mustNotClaim: '本地SOP/现有设备/实时数据/火线/响应等级',
    },
    {
      id: 'CN-UAV-EXPLAIN',
      title: '《森林草原防火 无人机巡查技术规范》国家标准解读材料',
      issuer: '国家市场监督管理总局',
      sourceType: '官方解读',
      officialUrl:
        'https://www.samr.gov.cn/bzjss/bzjd/art/2026/art_c60e23ad7ab846ba8909bc9962133bb0.html',
      dateOrEffective: '2026-02-24',
      usableFor: '日常巡查、火情巡查、准备实施完成与异常情况；非具体现场操作指令',
      kind: 'official_page',
      verifiedBy: 'web-search/review-2026-10-29',
      localFileIncluded: false,
      fullTextLicense: 'not-granted-or-unverified',
      mustNotClaim: '本地SOP/现有设备/实时数据/火线/响应等级',
    },
    {
      id: 'CN-VIDEO-47058',
      title: '森林草原防火视频监控系统技术规范 GB/T 47058—2026',
      issuer: '国家市场监督管理总局/国家标准化管理委员会',
      sourceType: '现行推荐国家标准',
      officialUrl:
        'https://openstd.samr.gov.cn/bzgk/std/newGbInfo?hcno=E56E8613B083CCA19D4F030A14F8EFFD',
      dateOrEffective: '2026-05-01',
      usableFor: '视频监控系统结构与数据获取参考',
      kind: 'standard_metadata',
      verifiedBy: 'web-search/review-2026-10-29',
      localFileIncluded: false,
      fullTextLicense: 'not-granted-or-unverified',
      mustNotClaim: '本地SOP/现有设备/实时数据/火线/响应等级',
    },
    {
      id: 'CN-SAFETY-35',
      title: '地方森林草原消防队伍火灾扑救安全指南 YJ/T 35—2025',
      issuer: '应急管理部',
      sourceType: '安全技术指南',
      officialUrl: 'https://yjglj.gz.gov.cn/gkmlpt/content/10/10574/post_10574836.html',
      dateOrEffective: '2025-10-15',
      usableFor: '安全培训与专业界限，不用研究卡片生成作战指令',
      kind: 'official_page',
      verifiedBy: 'web-search/review-2026-10-29',
      localFileIncluded: false,
      fullTextLicense: 'not-granted-or-unverified',
      mustNotClaim: '本地SOP/现有设备/实时数据/火线/响应等级',
    },
    {
      id: 'CN-BRIGADE-36',
      title: '地方森林草原消防队伍建设规范 YJ/T 36—2025',
      issuer: '应急管理部',
      sourceType: '队伍建设标准',
      officialUrl: 'https://www.mem.gov.cn/gk/zfxxgkpt/fdzdgknr/202512/W020251202420350636103.pdf',
      dateOrEffective: '2026-06-01',
      usableFor: '岗位、装备、训练与保障参考，不能证明本地实装',
      kind: 'official_pdf_direct',
      verifiedBy: 'web-search/review-2026-10-29',
      localFileIncluded: false,
      fullTextLicense: 'not-granted-or-unverified',
      mustNotClaim: '本地SOP/现有设备/实时数据/火线/响应等级',
    },
    {
      id: 'CN-ANHUI-5',
      title: '安徽省公布5起森林火灾（火情）典型案例',
      issuer: '安徽省应急管理厅',
      sourceType: '官方案例汇编',
      officialUrl: 'https://slcyfh.mem.gov.cn/kpxc/kpxczlm/202504/t20250429_533290.html',
      dateOrEffective: '2025-04-29',
      usableFor: '野外火源与火情原因、位置、时间等；真实森林案例',
      kind: 'official_page',
      verifiedBy: 'web-search/review-2026-10-29',
      localFileIncluded: false,
      fullTextLicense: 'not-granted-or-unverified',
      mustNotClaim: '本地SOP/现有设备/实时数据/火线/响应等级',
    },
    {
      id: 'CN-FORESTRY-RELAY',
      title: '大兴安岭十八站林业局打通空地一体化联动指挥通信渠道',
      issuer: '大兴安岭林业集团/国家林草局刊载',
      sourceType: '官方实践报道',
      officialUrl: 'https://www.forestry.gov.cn/c/www/lczhxx/691549.jhtml',
      dateOrEffective: '2026-10-10',
      usableFor: '卫星+无人机巡查图像回传实践，不等于平台现已接入',
      kind: 'official_case',
      verifiedBy: 'web-search/review-2026-10-29',
      localFileIncluded: false,
      fullTextLicense: 'not-granted-or-unverified',
      mustNotClaim: '本地SOP/现有设备/实时数据/火线/响应等级',
    },
    {
      id: 'CN-FORESTRY-DRONE',
      title: '无人机侦察+航空救援 智能手段助力森林火险防范更精确',
      issuer: '央视新闻/国家林草局刊载',
      sourceType: '官方技术实践报道',
      officialUrl: 'https://www.forestry.gov.cn/lyj/1/lczhxx/20260411/667066.html',
      dateOrEffective: '2026-04-11',
      usableFor: '视频监测与模拟拉练实际案例；不是本地真实部署证明',
      kind: 'official_case',
      verifiedBy: 'web-search/review-2026-10-29',
      localFileIncluded: false,
      fullTextLicense: 'not-granted-or-unverified',
      mustNotClaim: '本地SOP/现有设备/实时数据/火线/响应等级',
    },
    {
      id: 'CN-FORESTRY-PATROL',
      title: '福建莆田的村居森林防火模式创新',
      issuer: '国家林草局刊载',
      sourceType: '官方实践报道',
      officialUrl: 'https://www.forestry.gov.cn/lyj/1/dfdt/20260608/674415.html',
      dateOrEffective: '2026-06-08',
      usableFor: '村居巡护与日常火源管理实践资料',
      kind: 'official_case',
      verifiedBy: 'web-search/review-2026-10-29',
      localFileIncluded: false,
      fullTextLicense: 'not-granted-or-unverified',
      mustNotClaim: '本地SOP/现有设备/实时数据/火线/响应等级',
    },
    {
      id: 'CN-FORESTRY-WATCH',
      title: '大兴安岭开启森林防灭火新模式',
      issuer: '国家林业和草原局',
      sourceType: '官方实践报道',
      officialUrl: 'https://www.forestry.gov.cn/lyj/1/slfh/20230818/517819.html',
      dateOrEffective: '2023-08-18',
      usableFor: '瞭望塔可见光/热成像监测图示的公开案例；页面图片不直接抓取',
      kind: 'official_case',
      verifiedBy: 'web-search/review-2026-10-29',
      localFileIncluded: false,
      fullTextLicense: 'not-granted-or-unverified',
      mustNotClaim: '本地SOP/现有设备/实时数据/火线/响应等级',
    },
    {
      id: 'NASA-FIRMS',
      title: 'NASA FIRMS Area API',
      issuer: 'NASA',
      sourceType: '技术参考',
      officialUrl: 'https://firms.modaps.eosdis.nasa.gov/api/area/',
      dateOrEffective: '',
      usableFor: '卫星热点位置、观测时间和数据字段；不等同已确认火情/火场边界',
      kind: 'external_technical',
      verifiedBy: 'web-search/review-2026-10-29',
      localFileIncluded: false,
      fullTextLicense: 'not-granted-or-unverified',
      mustNotClaim: '本地SOP/现有设备/实时数据/火线/响应等级',
    },
    {
      id: 'CN-FORESTRY-NEWS-VIDEO',
      title: '视频｜守护森林、防火于未“燃”',
      issuer: '国家林草局宣传中心',
      sourceType: '官方科普视频入口',
      officialUrl: 'https://www.forestry.gov.cn/lyj/1/zhzs/20260930/690468.html',
      dateOrEffective: '2026-09-30',
      usableFor: '日常防火宣传；网页存在视频栏目但本轮未验证目标网络可播放',
      kind: 'official_media_page',
      verifiedBy: 'web-search/review-2026-10-29',
      localFileIncluded: false,
      fullTextLicense: 'not-granted-or-unverified',
      mustNotClaim: '本地SOP/现有设备/实时数据/火线/响应等级',
    },
    {
      id: 'CN-FIRE-PLAN-2020',
      title: '国家森林草原火灾应急预案（国办函〔2020〕99号）',
      issuer: '国务院办公厅',
      sourceType: '国家预案；需结合2026现行条例复核',
      officialUrl: 'https://www.beijing.gov.cn/zhengce/gwywj/202011/t20201124_2144062.html',
      dateOrEffective: '2020-11-23',
      usableFor: '历史预案结构，引用旧法规名称需结合现行条例确认；不等同本地SOP',
      kind: 'official_page',
      verifiedBy: 'web-search/review-2026-10-29',
      localFileIncluded: false,
      fullTextLicense: 'not-granted-or-unverified',
      mustNotClaim: '本地SOP/现有设备/实时数据/火线/响应等级',
    },
  ],
  pdfLinks: [
    {
      id: 'CN-SAFETY-35-PDF',
      title: '地方森林草原消防队伍火灾扑救安全指南 YJ/T 35—2025',
      directPdfUrl: 'https://yjglj.gz.gov.cn/attachment/7/7938/7938795/10574836.pdf',
      sourcePage: 'https://yjglj.gz.gov.cn/gkmlpt/content/10/10574/post_10574836.html',
      retrieval: 'official direct link confirmed in website, file not downloaded locally',
      rights: 'external-link-only',
    },
    {
      id: 'CN-BRIGADE-36-PDF',
      title: '地方森林草原消防队伍建设规范 YJ/T 36—2025',
      directPdfUrl: 'https://www.mem.gov.cn/gk/zfxxgkpt/fdzdgknr/202512/W020251202420350636103.pdf',
      sourcePage: 'https://www.mem.gov.cn/gk/zfxxgkpt/fdzdgknr/202512/W020251202420350636103.pdf',
      retrieval: 'official PDF viewed page one; file not downloaded locally',
      rights: 'external-link-only',
    },
    {
      id: 'CN-SPEC-3437-ONLINE',
      title: '森林草原防火信息系统技术要求 LY/T 3437—2025',
      directPdfUrl: '',
      sourcePage:
        'https://hbba.sacinfo.org.cn/portal/online/3f1fe2172df9130f6163608a7aa27272fdb7ea3ff3b8ce180e307480ba8815ed',
      retrieval: 'online preview/download provided by standards portal; no local copy',
      rights: 'online-preview',
    },
    {
      id: 'CN-UAV-47054-ONLINE',
      title: '森林草原防火 无人机巡查技术规范 GB/T 47054—2026',
      directPdfUrl: '',
      sourcePage:
        'https://openstd.samr.gov.cn/bzgk/std/newGbInfo?hcno=A4FFC9C8C97423178424C5ABFC8F3BCE',
      retrieval: 'standard portal can provide preview/download; no stable PDF URL verified',
      rights: 'online-preview',
    },
    {
      id: 'CN-VIDEO-47058-ONLINE',
      title: '森林草原防火视频监控系统技术规范 GB/T 47058—2026',
      directPdfUrl: '',
      sourcePage:
        'https://openstd.samr.gov.cn/bzgk/std/newGbInfo?hcno=E56E8613B083CCA19D4F030A14F8EFFD',
      retrieval: 'standard portal can provide preview/download; no stable PDF URL verified',
      rights: 'online-preview',
    },
  ],
  technical: [
    {
      key: 'FOREST-TECH-01',
      title: '卫星热点与多源核实',
      problemKeys: ['FOREST-ISSUE-01', 'FOREST-ISSUE-02'],
      implementation: '对照卫星热点时间位置和地面/视频/航空观察，不把热点直接认定为起火。',
      actualOutput: '热点记录与来源、待核查位置',
      referenceIds: ['CN-MON-2024', 'NASA-FIRMS'],
      rights: '研究链接示例',
      notProof: '不是实时火场边界或已接入卫星',
    },
    {
      key: 'FOREST-TECH-02',
      title: '无人机巡护与空中观察',
      problemKeys: ['FOREST-ISSUE-01', 'FOREST-ISSUE-02', 'FOREST-ISSUE-03'],
      implementation: '按允许的巡查条件记录可见光或相应机型的热像信息。',
      actualOutput: '空中影像、时间和位置线索',
      referenceIds: ['CN-UAV-47054', 'CN-UAV-EXPLAIN', 'CN-FORESTRY-DRONE'],
      rights: '官网外链',
      notProof: '不是任意型号都具备热像或可在浓烟中作业',
    },
    {
      key: 'FOREST-TECH-03',
      title: '瞭望塔与固定视频监控',
      problemKeys: ['FOREST-ISSUE-01', 'FOREST-ISSUE-03', 'FOREST-ISSUE-06'],
      implementation: '使用固定摄像与瞭望记录帮助区分观察时间和方向。',
      actualOutput: '历史视频、图像或瞭望记录',
      referenceIds: ['CN-MON-2024', 'CN-VIDEO-47058', 'CN-FORESTRY-WATCH'],
      rights: '官网外链',
      notProof: '视频盲区不等于没有火情',
    },
    {
      key: 'FOREST-TECH-04',
      title: '林区气象与植被信息',
      problemKeys: ['FOREST-ISSUE-02'],
      implementation: '关联时间地点有效的天气及植被资料，用于研究环境条件。',
      actualOutput: '风、温湿度、降水与植被资料',
      referenceIds: ['CN-MON-2024', 'CN-REG-822'],
      rights: '结构化参考',
      notProof: '不能根据单项值自动设响应级别',
    },
    {
      key: 'FOREST-TECH-05',
      title: '偏远林区卫星通信与无人机回传',
      problemKeys: ['FOREST-ISSUE-04', 'FOREST-ISSUE-05'],
      implementation: '按官方实践报道展示卫星地面站与无人机图像回传的协作关系。',
      actualOutput: '链路测试结果、视频或语音可达记录',
      referenceIds: ['CN-FORESTRY-RELAY', 'CN-MON-2024'],
      rights: '官网外链',
      notProof: '不是我方平台已经部署的通信方案',
    },
    {
      key: 'FOREST-TECH-06',
      title: '巡护台账与火源风险资料',
      problemKeys: ['FOREST-ISSUE-06'],
      implementation: '按区域和时间整理巡护、检查及官方案例条目。',
      actualOutput: '巡护记录与风险来源',
      referenceIds: ['CN-ANHUI-5', 'CN-REG-822', 'CN-FORESTRY-PATROL'],
      rights: '官方案例链接',
      notProof: '不能自动判定人员违法或事故原因',
    },
  ],
  mediaLinks: [
    {
      id: 'VIDEO-FOREST-2026',
      title: '守护森林、防火于未“燃”',
      issuer: '国家林草局宣传中心',
      url: 'https://www.forestry.gov.cn/lyj/1/zhzs/20260930/690468.html',
      scope: '日常巡护和公众防火意识',
      embedRights: 'unknown; link only',
      playbackInChina: 'not-tested',
    },
    {
      id: 'PRACTICE-FOREST-RELAY',
      title: '空地一体化通信渠道实践',
      issuer: '国家林业和草原局',
      url: 'https://www.forestry.gov.cn/c/www/lczhxx/691549.jhtml',
      scope: '林区回传与中继',
      embedRights: 'link only',
      playbackInChina: 'article',
    },
    {
      id: 'PRACTICE-FOREST-DRONE',
      title: '无人机侦察与航空救援应用观察',
      issuer: '国家林业和草原局',
      url: 'https://www.forestry.gov.cn/lyj/1/lczhxx/20260411/667066.html',
      scope: '监测与演练，不是某一型号能力认证',
      embedRights: 'link only',
      playbackInChina: 'article',
    },
    {
      id: 'NIST-EDU-NASA',
      title: 'NASA FIRMS技术资料',
      issuer: 'NASA',
      url: 'https://firms.modaps.eosdis.nasa.gov/api/area/',
      scope: '热点信息字段与限制',
      embedRights: 'link only',
      playbackInChina: 'not-tested',
    },
  ],
} as const;
